import React from 'react';
import PropTypes from 'prop-types';

import { SLOT_VALUE } from 'Components/Skeleton/SkeletonImg';

/**
 * The strip banner under a take over or the carousel background campaign (Components/Banner/StripBanner), for page
 * skeletons: a bar of its height without the message, which depends on the language and currency. Like the app, it
 * only shows with the image it's under, so there's a bar for each: from md up when the worker has
 * `<slot>-desktop`, below md when it has `<slot>-mobile` (`data-skeleton-if`).
 * Slots: `<slot>-desktop`, `<slot>-mobile` (any value when shown), `<slot>-colour` (custom background colour).
 */
export default function SkeletonStripBanner({ slot }) {
  return ['desktop', 'mobile'].map(device => (
    <div
      key={device}
      className={`SkeletonStripBanner SkeletonStripBanner--${device}`}
      data-skeleton-if={`${slot}-${device}`}
      data-skeleton-slot={`${slot}-colour`}
      data-slot-style={`background-color: ${SLOT_VALUE}`}
    />
  ));
}

SkeletonStripBanner.propTypes = {
  slot: PropTypes.string.isRequired,
};
